export default {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};
